/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'no_material': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M11.681 3.798a.292.292 0 01.323.001l9.198 6.798c.026.02.037.036.042.045.005.01.006.018.006.024a.05.05 0 01-.006.024.136.136 0 01-.043.046l-8.882 6.466a.292.292 0 01-.323-.001l-9.198-6.798a.135.135 0 01-.042-.045.051.051 0 01-.006-.024c0-.006.001-.014.006-.024a.137.137 0 01.043-.046l8.882-6.466z" _stroke="currentColor" stroke-width="1.5"/><path pid="1" d="M2.358 13a.817.817 0 00-.005 1.348l9.197 6.798c.352.26.856.261 1.21.004l8.882-6.466a.817.817 0 00.006-1.348" _stroke="currentColor" stroke-width="1.5"/><path pid="2" d="M10 12.331L14.331 8M10 8l4.331 4.331" _stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>'
  }
})
